export const htmlTutorials = [
  {
    id: 0,
    school: "MDM",
    courseName: "Structuring the web with HTML",
    src: "https://developer.mozilla.org/en-US/docs/Learn/HTML",
    summary: `HTML is used to specify whether your web content should be recognized as a paragraph, list, heading, link, image, multimedia player, form, or one of many other available elements or even a new element that you define.`,
  },
  {
    id: 1,
    school: "W3schools",
    courseName: "HTML Tutorial",
    src: "https://www.w3schools.com/html/default.asp",
    summary: `At W3Schools, I've found complete references about HTML elements, attributes, events, color names, entities, character-sets, URL encoding, language codes, HTTP messages, browser support, and more...`,
  },
  {
    id: 2,
    school: "Mosh",
    courseName: "The Ultimate HTML/CSS Mastery Series",
    src: "https://codewithmosh.com/p/the-ultimate-html-css",
    summary: `This was a perfectly-structured course packed with exercises, solutions, and a real project. I have learned and understand the what's, why's and how's of HTML and CSS.`,
    certificate:
      "https://html2-f.scribdassets.com/3zlf6y36rk8hs848/images/1-5515c61890.jpg",
  },
];

export const cssTutorials = [
  {
    id: 0,
    school: "freeCodeCamp",
    courseName: "Legacy Responsive Web Design",
    src: "https://www.freecodecamp.org/learn/responsive-web-design/",
    summary: `TFirst, you'll build a cat photo app to learn the basics of HTML and CSS. Later, you'll learn modern techniques like CSS variables by building a penguin, and best practices for accessibility by building a web form. Finally, you'll learn how to make webpages that respond to different screen sizes by building a Twitter card with Flexbox, and a complex blog layout with CSS Grid.`,
    certificate:
      "https://www.freecodecamp.org/certification/footios/front-end-development-libraries",
  },
  {
    id: 1,
    school: "W3schools",
    courseName: "CSS Tutorial",
    src: "https://www.w3schools.com/css/",
    summary: `CSS is the language we use to style an HTML document. CSS describes how HTML elements should be displayed. This tutorial will teach you CSS from basic to advanced.`,
  },
  {
    id: 2,
    school: "Mosh",
    courseName: "The Ultimate HTML/CSS Mastery Series",
    src: "https://codewithmosh.com/p/the-ultimate-html-css",
    summary: `This was a perfectly-structured course packed with exercises, solutions, and a real project. I have learned and understand the what's, why's and how's of HTML and CSS.`,
    certificate:
      "https://html2-f.scribdassets.com/3zlf6y36rk8hs848/images/1-5515c61890.jpg",
  },
  {
    id: 3,
    school: "MDM",
    courseName: "CSS Tutorials",
    src: "https://developer.mozilla.org/en-US/docs/Web/CSS/Tutorials",
    summary: `Media queries, CSS Animations, CSS Transitions, CSS Transforms, CSS flexible boxes layouts`,
  },
];

export const sassTutorials = [
  {
    id: 0,
    school: "Sass",
    courseName: "Structuring the web with HTML",
    src: "https://sass-lang.com/guide",
    summary: `Sass is a stylesheet language that’s compiled to CSS. It allows you to use variables, nested rules, mixins, functions, and more, all with a fully CSS-compatible syntax. Sass helps keep large stylesheets well-organized and makes it easy to share design within and across projects.`,
  },
  {
    id: 1,
    school: "freeCodeCamp",
    courseName: "Sass Tutorial - CSS With Superpowers",
    src: "https://www.youtube.com/watch?v=nu5mdN2JIwM&t=1807s&ab_channel=TraversyMedia",
    summary: `In this course, you will learn the basics of Sass. We will start with a brief overview of what Sass is along with what is required to incorporate Sass into your environment. We will also set up a Sass compiler in Visual Studio Code. You will learn about Sass variables, maps, nesting, functions, mixins, extending, and operations.`,
  },
];

export const tailwind = [
  {
    id: 0,
    school: "Programming With Yash",
    courseName: "Portfolio Using Tailwind",
    src: "https://www.youtube.com/watch?v=LpZrAjU6Hhk&t=1s&ab_channel=ProgrammingWithYash",
    summary: ` My take on responsive React portfolio website from scratch using Tailwind CSS and deploying it to server. In this tutorial, we will work with JavaScript, React, and Tailwind. `,
  },
  {
    id: 1,
    school: "The Net Ninja",
    courseName: "Tailwind CSS Tutorial",
    src: "https://www.youtube.com/playlist?list=PL4cUxeGkcC9gpXORlEHjc5bgnIi5HEGhw",
    summary: `In this tailwind css tutorial we'll take a look at what tailwind css is, how to use it & set up a new project.`,
  },
];

export const javascript = [
  {
    id: 0,
    school: "Anto Aravinth",
    courseName: "Beginning Functional JavaScript (Book)",
    src: "https://www.amazon.com/Beginning-Functional-JavaScript-Programming-EcmaScript/dp/1484226550",
    summary: `Learn functional programming concepts using JavaScript ES6. You will learn concepts such as currying, partial functions, higher-order functions, and monads. Programming languages have evolved from focusing on procedures to objects and now on function. JavaScript supports functional programming and allows developers to write well-crafted code.`,
  },
  {
    id: 1,
    school: "Douglas Crockford",
    courseName: "JavaScript, The Good Parts (Book)",
    src: "https://www.amazon.com/JavaScript-Good-Parts-Douglas-Crockford/dp/0596517742",
    summary: `Most programming languages contain good and bad parts, but JavaScript has more than its share of the bad, having been developed and released in a hurry before it could be refined. This authoritative book scrapes away these bad features to reveal a subset of JavaScript that's more reliable, readable, and maintainable than the language as a whole—a subset you can use to create truly extensible and efficient code.`,
  },
  {
    id: 2,
    school: "J. Resig, B. Bibeault, and J. Maras",
    courseName: "Secrets of the JavaScript Ninja (Book)",
    src: "https://www.manning.com/books/secrets-of-the-javascript-ninja-second-edition",
    summary: `Secrets of the JavaScript Ninja, Second Edition uses practical examples to clearly illustrate each core concept and technique. This completely revised edition shows you how to master key JavaScript concepts such as functions, closures, objects, prototypes, and promises. It covers APIs such as the DOM, events, and timers. `,
  },
  {
    id: 3,
    school: "Kyle Simpson",
    courseName: "You Don't Know JS Yet: Scope & Closures (Book)",
    src: "https://leanpub.com/ydkjsy-scope-closures",
    summary: `The foundation of all programs is organization of variables/functions into nested scopes. Yet, many never contemplate how & why these decisions are made and the impacts on code maintainability. Scope & Closures examines lexical scope, builds on its principles for the power of closure, and digs into the module pattern for better program structure.`,
  },
  {
    id: 4,
    school: "freeCodeCamp",
    courseName: "JavaScript Algorithms and Data Structures",
    src: "https://www.freecodecamp.org/learn/javascript-algorithms-and-data-structures/",
    summary: `In the JavaScript Algorithm and Data Structures Certification, you'll learn the fundamentals of JavaScript including variables, arrays, objects, loops, and functions. Once you have the fundamentals down, you'll apply that knowledge by creating algorithms to manipulate strings, factorialize numbers, and even calculate the orbit of the International Space Station.`,
    certificate:
      "https://www.freecodecamp.org/certification/footios/javascript-algorithms-and-data-structures",
  },
  {
    id: 5,
    school: "Maximilian Schwarzmüller",
    courseName: "Accelerated ES6 JavaScript Training",
    src: "https://www.udemy.com/course/es6-bootcamp-next-generation-javascript/?utm_source=adwords&utm_medium=udemyads&utm_campaign=WebDevelopment_v.PROF_la.EN_cc.ROWMTA-A_ti.8322&utm_content=deal4584&utm_term=_._ag_77741649963_._ad_533999949985_._kw__._de_c_._dm__._pl__._ti_dsa-774930035449_._li_9067666_._pd__._&matchtype=&gclid=Cj0KCQjwy5maBhDdARIsAMxrkw1tVVFIdWgHL6VQRr87OEhcAXN3hkg6BkgZ8B523qsKuLmvK4eGMegaArrvEALw_wcB",
    summary: `This course follows a hands-on, example-driven approach to show and explain all the important features added to JavaScript. This includes important syntax changes and additions like let, const, rest & spread operators and continues with Promises, the Reflect API, the Proxy API, Maps & Sets, tons of new methods and functions and much more!`,
    certificate:
      "https://www.udemy.com/certificate/UC-f55ddce2-b552-4788-8779-b83f23f3b2cf/",
  },
  {
    id: 6,
    school: "Mosh",
    courseName: "The Ultimate JavaScript Series",
    src: "https://codewithmosh.com/p/ultimate-javascript-series",
    summary: `By the end of this course, you'll be able to…
    Develop and debug modern JavaScript programs with confidence
    Understand and troubleshoot common errors
    Get ready to learn web/mobile development with JavaScript frameworks
    Apply today's best practices`,
    certificate:
      "https://www.scribd.com/document/600159077/Certificate-of-Completion-for-Object-Oriented-Programming-in-Javascript",
  },
  {
    id: 7,
    school: "javascript.info",
    courseName: "The Modern JavaScript Tutorial",
    src: "https://javascript.info/",
    summary: `Main course contains 2 parts which cover JavaScript as a programming language and working with a browser. There are also additional series of thematic articles.`,
  },
  {
    id: 8,
    school: "MDN",
    courseName: "JavaScript",
    src: "https://developer.mozilla.org/en-US/docs/Web/JavaScript",
    summary: `JavaScript (JS) is a lightweight, interpreted, or just-in-time compiled programming language with first-class functions. It is a prototype-based, multi-paradigm, single-threaded, dynamic language, supporting object-oriented, imperative, and declarative styles. `,
  },
];

export const typescript = [
  {
    id: 0,
    school: "Maximilian Schwarzmüller",
    courseName: "Understanding TypeScript",
    src: "https://www.udemy.com/course/understanding-typescript/learn/lecture/16935728?start=0#overview",
    summary: `This course takes you from the very basics and its most important feature (types!) to the point where you're able to use TypeScript in any of your projects. ReactJS projects included! `,
    certificate:
      "https://www.udemy.com/certificate/UC-e510b1b2-1517-4bac-9570-599b8377a5ca/",
  },
  {
    id: 1,
    school: "Code Evolution",
    courseName: "Learn TypeScript in 50 Minutes",
    src: "https://www.youtube.com/watch?v=WBPrJSw7yQA&ab_channel=Codevolution",
    summary: `In this typescript tutorial for beginners, we go over the fundamental concepts like variable declarations, variable types, functions, interfaces, classes and access modifiers.`,
  },
  {
    id: 2,
    school: "typescriptlang.org",
    courseName: "The TypeScript Handbook",
    src: "https://www.typescriptlang.org/docs/handbook/intro.html",
    summary: `A reader who completes the walkthrough should be able to:
    Read and understand commonly-used TypeScript syntax and patterns
    Explain the effects of important compiler options
    Correctly predict type system behavior in most cases.`,
  },
];

export const react = [
  {
    id: 0,
    school: "Maximilian Schwarzmüller",
    courseName: "React - The Complete Guide",
    src: "https://www.udemy.com/course/react-the-complete-guide-incl-redux/",
    summary: `Dive in and learn React.js from scratch! Learn Reactjs, Hooks, Redux, React Routing, Animations, Next.js and way more! `,
    certificate: "https://www.udemy.com/certificate/UC-OFS6RM1N/",
  },
  {
    id: 1,
    school: "Reed Barger",
    courseName: "Hacker News Clone",
    src: "https://www.udemy.com/course/draft/2365180/",
    summary: `Throughout this course, we'll be building a live chat app for developers called DevChat, where users will be able to create channels, to send messages to other users on those channels, send media files, see when other users are typing, add emojis to their messages, favorite and unfavorite channels they like or dislike, and get notifications about new messages on other channels.`,
    certificate:
      "https://udemy-certificate.s3.amazonaws.com/image/UC-1cee0f9a-8e3f-44a3-96aa-9cac7148d23b.jpg",
  },
  {
    id: 2,
    school: "Reed Barger",
    courseName: "Build a Slack Chat",
    src: "https://www.udemy.com/course/draft/1806572/",
    summary: `Throughout this course, we'll be building a live chat app for developers called DevChat, where users will be able to create channels, to send messages to other users on those channels, send media files, see when other users are typing, add emojis to their messages, favorite and unfavorite channels they like or dislike, and get notifications about new messages on other channels.`,
    certificate:
      "https://www.udemy.com/certificate/UC-5cd6d915-03d0-485c-b6d0-047fac442c77/",
  },
  {
    id: 4,
    school: "freeCodeCamp",
    courseName: "Front End Development Libraries",
    src: "https://www.udemy.com/course/react-the-complete-guide-incl-redux/",
    summary: `In the Front End Development Libraries Certification, you'll learn how to style your site quickly with Bootstrap. You'll also learn how add logic to your CSS styles and extend them with Sass. Later, you'll build a shopping cart and other applications to learn how to create powerful Single Page Applications (SPAs) with React and Redux.`,
    certificate:
      "https://www.freecodecamp.org/certification/footios/front-end-development-libraries",
  },
  {
    id: 5,
    school: "Code with Mosh",
    courseName: "Mastering React",
    src: "https://codewithmosh.com/p/mastering-react",
    summary: `Highly technical with a perfect mix of theory and practice. It covers absolutely every detail you could possibly need to take you from beginner React developer to an expert.`,
    certificate:
      "https://html2-f.scribdassets.com/6d4hi2af288kkpbj/images/1-f1c5edcf81.jpg",
  },
  {
    id: 6,
    school: "Maximilian Schwarzmüller",
    courseName: "React Native - The Practical Guide",
    src: "https://www.udemy.com/course/react-native-the-practical-guide/",
    summary: `You'll learn all about the theory behind React Native, its core concepts, how to build responsive designs that work on different device sizes, how to navigate around, use maps and the camera and so much more!    .`,
    certificate: "https://www.udemy.com/certificate/UC-2J8PFHYP/",
  },
  {
    id: 7,
    school: "Jason Brown",
    courseName: "Master React Native Animations ",
    src: "https://www.udemy.com/course/react-the-complete-guide-incl-redux/",
    summary: `In this course we'll start by walking through all of the functions and animation types that you can leverage with React Native.
    We'll step it up to some advanced topics live interpolating colors, rotations, using extrapolate, .99 cliffs, interrupted animations and many more concepts.
    After that we'll learn how Animated actually works and rebuild some custom animations using d3-interpolate and other libraries to animate SVG paths. Finally we get to the real world. We'll use our new found knowledge of Animated to breakdown animations into their pieces, and then rebuild them with the Animated library.`,
    certificate:
      "https://www.udemy.com/certificate/UC-c17787c2-ff4a-4146-aebc-25d9eabc2a7b/",
  },
  {
    id: 8,
    school: "Code with Mosh",
    courseName: "The Ultimate React Native Series",
    src: "https://codewithmosh.com/p/the-ultimate-react-native-course",
    summary: `This course teaches you everything you need to build real apps with React Native from scratch. No fluff, no lengthy, repetitive explanations to waste your time. This course is divided into two parts: basics and advanced topics. Each part is about 5 hours long so you can easily complete it.`,
    certificate:
      "https://html1-f.scribdassets.com/7zaxai4fwg8kkpks/images/1-fd322c7848.jpg",
  },
  {
    id: 8,
    school: "William Candilon",
    courseName: "Start React Native",
    src: "https://start-react-native.dev/",
    summary: `Build Delightful
    Gestures and Animations
    Learn React Native Gesture Handler and Reanimated to build user experiences that run at 60 fps, even on low-end devices.`,
  },
  {
    id: 9,
    school: "Reactiive",
    courseName: "Animate with Reanimated 2",
    src: "https://www.youtube.com/watch?v=yz9E10Dq8Bg&list=PLjHsmVtnAr9TWoMAh-3QMiP7bPUqPFuFZ",
    summary: `YouTube series where we learn Reanimated 2, by building small projects.`,
  },
];
